import { useEffect, useState } from 'react';
import { KioskItem as KioskItemCmp } from './KioskItem';
import { OwnedObjectType } from '../Inventory/OwnedObjects';
import { Loading } from '../Base/Loading';
import { useNavigate } from 'react-router-dom';
import { useKiosk, useOwnedKiosk } from '../../../hooks/kiosk';
import { SudoCardDetails } from '../Modals/SudoCardDetails';
import { KioskOwnerCap } from '@mysten/kiosk';

export function KioskItems({
  address,
  kioskId,
  kioskCap,
}: {
  address: string;
  kioskId?: string;
  kioskCap: KioskOwnerCap;
}) {
  const { data: walletKiosk } = useOwnedKiosk(address);

  const [modalItem, setModalItem] = useState<OwnedObjectType | null>(null);

  const {
    data: kioskData,
    isLoading,
    isError,
    refetch: refreshKioskData,
  } = useKiosk(kioskId);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isError) return;
  }, [navigate, isError]);

  if (!kioskId)
    return <div className="py-12">Supply a kiosk ID to continue.</div>;

  if (isLoading) return <Loading />;

  if (!kioskId || !kioskData || kioskData.items.length === 0)
    return <div className="py-12">The kiosk you are viewing is empty!</div>;

  return (
    <div className="mt-12">
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-5">
        {kioskData.items.map((item: OwnedObjectType) => (
          <KioskItemCmp
            key={item.objectId}
            kioskId={kioskId}
            item={item}
            hasKiosk={!!walletKiosk?.kioskId}
            showFn={(item: OwnedObjectType) => setModalItem(item)}
          />
        ))}
        {modalItem && (
          <SudoCardDetails
            item={modalItem}
            kioskCap={kioskCap}
            refreshKiosk={refreshKioskData}
            closeModal={() => setModalItem(null)}
          ></SudoCardDetails>
        )}
      </div>
    </div>
  );
}
